import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './containers/App/App'
import registerServiceWorker from './registerServiceWorker'
import Raven from 'raven-js'

if (process.env.NODE_ENV === 'production') {
  Raven.config('https://9e789679a5144449825253be059711e1@sentry.io/202954', {
    release: '2.0.0'
  }).install()
}

// Grab the state from script injected into the server-generated HTML
// let props = document.getElementById('app-data').textContent
//
// // Get rid of unwanted stuff to get a clean json object
// props = props
//   .replace('<![CDATA[', '')
//   .replace(']]>', '')
//   .replace("'", '')
//   .replace("'", '')

// Check if props is the real data or just the placeholder and json parse it
const initialData = false

ReactDOM.render(
  <BrowserRouter>
    <App initialData={initialData} />
  </BrowserRouter>,
  document.getElementById('root')
)

if (process.env.NODE_ENV === 'production') registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js